/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { TimesheetPagination } from '../Timesheet/TimesheetPagination';
import { Grid } from '@mui/material';

import {
  Table,
  TableContainer,
  CircularProgress,
  Typography,
} from '@mui/material';

const loadingStyle = {
  display: 'block',
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export const GeneralTable = (props) => {
  return (
    <>
      <CircularProgress
        sx={props.isDataLoading ? loadingStyle : { display: 'none' }}
      />
      <Typography
        textAlign="center"
        sx={props.noRecord ? { display: 'block', my: 10 } : { display: 'none' }}
      >
        No Record Found.
      </Typography>
      <TableContainer sx={props.sx}>
        <Table size={props.size} sx={{ minWidth: '100%' }}>
          {props.children}
        </Table>
      </TableContainer>

      <Grid container alignItems="center" spacing={2} sx={{ mb: 3 }}>
        {/* Left: Entries dropdown */}
        <Grid
          item
          xs={4}
          sx={{ display: 'flex', justifyContent: 'flex-start' }}
        >
          {props.entriesPerPageComponent && props.entriesPerPageComponent}
        </Grid>

        {/* Center: Pagination */}
        <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center' }}>
          <TimesheetPagination
            count={
              props.pageCountExact
                ? props.pageCount
                : props.length % props.entryPerPage !== 0
                  ? props.pageCount + 1
                  : props.pageCount
            }
            onChange={props.handlePageChange}
            page={props.page}
            noRecord={props.noRecord}
          />
        </Grid>

        {/* Right: Placeholder */}
        <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          {/* You can put something here if needed */}
        </Grid>
      </Grid>
    </>
  );
};
